RFM_APP.factory('requestMilesService', ['$http', '$q', function($http, $q) {
    var formData = null;
    var summary = null;
    var labels = null;
    var airlinesData = null;
    var messageCode = null;
    var webAnalyticsData = [];
    var pageErrorCodes = [];
    var sameUser = 'N';
    
    function clearPageErrorCodes() {
        webAnalyticsData = [];
        delete utag_data.error_id;
        delete utag_data.request_miles_airline;
    }
    function pushPageErrorCode(errorCodeId) {
        pageErrorCodes.push(errorCodeId);
    }
    function getPageErrorCodes() {
        pageErrorCodes.sort();
        return pageErrorCodes.join(",");
    }
    function addToWebAnalytics (key, value) {
        webAnalyticsData.push(new KeyValueObject(key, value));
    }
    
    function reportToWebAnalytics() {
        $http.post("/forms/request-flight-miles/populateUtagData").then(
            function(response){
                webAnalyticsData.push(new KeyValueObject('time_stamp', response.data.time_stamp));
                webAnalyticsData.push(new KeyValueObject('channel', 'AAdvantage'));
                waTealiumUtils.reportEvent(webAnalyticsData, "view");
                webAnalyticsData = [];
            }, function(error){
            });
    }
    
    function setLabels(formLabels){
        labels = formLabels;
    }
    function getLabels(){
        return labels;
    }
    function getFormData(){
        return formData;
    }
    
    function searchFlightDetails(landingPayLoad){
        var defer = $q.defer();
        $http.post("/forms/request-flight-miles/performSearch", landingPayLoad).then(
            function(response){
                airlinesData = [];
                summary = null;
                messageCode = null;
                formData = {};
                pageErrorCodes = [];
                formData.landingPayload = landingPayLoad;
                formData.passengerDetails = response.data;
                defer.resolve(response);
            }, function(error){
                defer.reject(error);
            });
        return defer.promise;
        
    }
    
    function populateSummary(summaryPayLoad){
        var defer = $q.defer();
        $http.post("/forms/request-flight-miles/populateSummary", summaryPayLoad).then(
            function(response){
                airlinesData = [];
                summary = {};
                messageCode = null;
                pageErrorCodes = [];
                summary.payLoad = summaryPayLoad;
                summary.response = response.data
                defer.resolve(response);
            },function(error){
                defer.reject(error);        
            });
        return defer.promise;
    }
    
    function submitSummary(finalPayLoad){
        var defer = $q.defer();
        $http.post("/forms/request-flight-miles/onConfirmSubmit", finalPayLoad).then(
            function(response){
                airlinesData = [];
                populateAirlinesData(summary.response)
                summary = {};
                formData = {};
                messageCode = null;
                pageErrorCodes = [];
                formData.passengerDetails = [];
                defer.resolve(response);
            }, function(error){
                defer.reject(error);
            });
        return defer.promise;
        
    }
    function getSummary(){
        return summary;
    }
    function populateAirlinesData(flightSummary) {
        flightSummary.forEach( function (flightDetail) {
            airlinesData.push(flightDetail.airlineFlown);
        });
    }
    function getAirlinesData() {
    	if(airlinesData != undefined || airlinesData != null) {
    		return airlinesData.join("|");
    	} else {
    		return null;
    	}
    }
    function setMessageCodeForConfirmationPage(code) {
    	 messageCode = code;
    }
    function getMessageCodeForConfirmationPage() {
   	 return messageCode;
   }
    function doListSorting(itemsArray, sortingArr) {
        var sortedArray = [];
        if(itemsArray != undefined) {
            for(var k=0; k < itemsArray.length; k++) {
                var listKeys = Object.keys(itemsArray);
                var itemsArrayListObj = itemsArray[listKeys[k]]
                var itemsKeys = Object.keys(itemsArrayListObj);
                for(var i=0; i < sortingArr.length; i++) {
                    var found = false;
                    for(var j=0; j < itemsKeys.length && !found; j++) {
                        if(itemsKeys[j] == sortingArr[i]) {
                            sortedArray.push(itemsKeys[j]+k);
                            var errorCodeId = itemsArrayListObj[(itemsKeys[j])+'Code'];
                            pageErrorCodes.push(errorCodeId);
                            itemsKeys.splice(j,1);
                            found = true;
                        }
                    }
                }
            }
        }
        return sortedArray;
    }
    function overrideSkipLinks() {
        $j("*[id*='aa-meta-skip']  a").each(function() {
            var hrefValue = $j(this).attr('href');
            $j(this).attr('href', '');
            $j(this).on("click", function (event) {
                event.preventDefault();
                $j(hrefValue).focus();
            });
        });
    }
    
    function doSorting(itemsArray, sortingArr) {
        var sortedArray = [];
        if(itemsArray != undefined) {
            var itemsKeys = Object.keys(itemsArray);
            
            for(var i=0; i < sortingArr.length; i++) {
                var found = false;
                for(var j=0; j < itemsKeys.length && !found; j++) {
                    if(itemsKeys[j] == sortingArr[i]) {
                        sortedArray.push(itemsKeys[j]);
                        var errorCodeId;
                        if (itemsKeys[j] == 'primaryPhone') {
                            errorCodeId = itemsArray[itemsKeys[j]]['numberCode'];
                        } else {
                            errorCodeId = itemsArray[itemsKeys[j]+'Code'];
                        }
                        pageErrorCodes.push(errorCodeId);
                        itemsKeys.splice(j,1);
                        found = true;
                    }
                }
            }
        }
        return sortedArray;
    }
    
    function isSameUser() {
    	return sameUser;
    }
    
    function setSameUser(_sameUser) {
    	sameUser = _sameUser;
    }
    
    return {
        getFormData : getFormData,
        searchFlightDetails: searchFlightDetails,
        submitSummary: submitSummary,
        populateSummary: populateSummary,
        getSummary : getSummary,
        doSorting : doSorting,
        doListSorting : doListSorting,
        getLabels : getLabels,
        setLabels : setLabels,
        addToWebAnalytics  : addToWebAnalytics,
        reportToWebAnalytics : reportToWebAnalytics,
        overrideSkipLinks : overrideSkipLinks,
        clearPageErrorCodes : clearPageErrorCodes,
        pushPageErrorCode : pushPageErrorCode,
        getPageErrorCodes : getPageErrorCodes,
        getAirlinesData : getAirlinesData,
        populateAirlinesData : populateAirlinesData,
        setMessageCodeForConfirmationPage : setMessageCodeForConfirmationPage,
        getMessageCodeForConfirmationPage : getMessageCodeForConfirmationPage,
        isSameUser : isSameUser,
        setSameUser : setSameUser
    };
  }]);